




























































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { GetResultList$, GetExamDetail$ } from "@/request/jxgl";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../components/left-nav.vue";
import ResultTable from "./result-list.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    ResultTable,
    Pagination,
  },
})
export default class SzksResultList extends Vue {
  private examId: any = "";
  private filters: any = {
    search: "",
    current_page: 1,
    total_count: 0,
    page_count: 10,
    order_value: 0,
  };
  private exam: any = {};
  // 列表
  private results: any = {};
  private setFilters() {
    localStorage.setItem("ksglResultFilters", JSON.stringify(this.filters));
  }
  /**
   * @description 跳转考试管理列表
   */
  private jumpKsgl() {
    this.$router.push("/main/jxgl/ksgl-list");
  }
  /**
   * @description 获取考试详情
   */
  private fetchExamDetail() {
    GetExamDetail$(this, { params: { exam_id: this.examId } }).then(
      (data: any) => {
        this.exam = data;
      }
    );
  }
  /**
   * @description 获得考试记录列表
   */
  private fetchResultList() {
    const params = _.cloneDeep(this.filters);
    params["exam_id"] = this.examId;
    GetResultList$(this, params).then((data: any) => {
      this.$set(this, "results", data);
      this.filters.total_count = data.total_count;
      this.setFilters();
    });
  }
  /**
   * @description 改变排序顺序
   */
  private changeOrderValue() {
    this.filters.order_value = this.filters.order_value === 0 ? 1 : 0;
    this.search();
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.current_page = 1;
    this.fetchResultList();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.filters.current_page = val;
    this.fetchResultList();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    const localFilters = localStorage.getItem("ksglResultFilters");
    if (!localFilters) {
      this.$set(this, "filters", {
        search: "",
        current_page: 1,
        total_count: 0,
        page_count: 10,
        order_value: 0,
      });
    } else {
      this.$set(this, "filters", JSON.parse(localFilters));
    }
    this.examId = this.$route.query.id;
    this.fetchExamDetail();
    this.fetchResultList();
  }
}
